import { useCallback } from 'react';
import Button from '@paradigm/design-system/src/components/Button';
import { useRfqBuilderModalMethods } from '@paradigm/features/src/unified-rfqs/ui/rfq-builder/modal-context';
import { useUMPlatformCreationDisabled } from '@paradigm/features/src/platform-state/contexts/providers';
import { useTrackAction } from '@paradigm/features/src/analytics';

export default function OpenRfqBuilderButton() {
  const { open } = useRfqBuilderModalMethods();
  const isPlatformCreationDisabled = useUMPlatformCreationDisabled();
  const label = 'Create';
  const trackAction = useTrackAction();
  const handleClick = useCallback(() => {
    trackAction('create market');
    open();
  }, [open, trackAction]);
  return (
    <Button
      ariaLabel={label}
      size="large"
      disabled={isPlatformCreationDisabled}
      onClick={handleClick}
    >
      {label}
    </Button>
  );
}
